module.exports = __webpack_public_path__ + "static/media/icon-pressure-dark.8126a5a9.svg";